module.exports = __webpack_public_path__ + "img/house_battery_off.1c40993b.png";